import gql from 'graphql-tag';
import FieldsBuilding from "graphql/fields/FieldsBuilding";
import FieldsEmployee from "graphql/fields/FieldsEmployee";
import FieldsDepartment from "graphql/fields/FieldsDepartment";
import FieldsJobtitle from "graphql/fields/FieldsJobtitle";

export default gql(`
	query buildings( $scanInAtDate: String, $bookingDate: [String], $bookingStatus: [String], $bookingKind: [String], $bookingSubKind: [String], $buildings: [String]) {
		buildings (guid: $buildings) {
			${FieldsBuilding}
			
			bookings( booking_date: $bookingDate, status: $bookingStatus, kind: $bookingKind, sub_kind: $bookingSubKind ) {
				guid
				
				employee {
					${FieldsEmployee}
				}
			}
			
			scans( scanned_in_at: $scanInAtDate ) {
				guid
				code
				scanned_in_at
				scanned_in_through
				
				employee {
					${FieldsEmployee}
					
					department {
						${FieldsDepartment}
					}
					
					jobtitle{
						${FieldsJobtitle}
					}
				}
			}
		}
	}
`);

